import { render, staticRenderFns } from "./authentice-face.vue?vue&type=template&id=4dbe56c8&scoped=true"
import script from "./authentice-face.vue?vue&type=script&lang=js"
export * from "./authentice-face.vue?vue&type=script&lang=js"
import style0 from "./authentice-face.vue?vue&type=style&index=0&id=4dbe56c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbe56c8",
  null
  
)

export default component.exports